/**
 * Template labels sometimes stored legacy "7. Title" or "11a. Title" prefixes while the UI
 * prefixes the visible position (e.g. "6. 7. Title"). Strip one leading numbered segment.
 */
export function stripLeadingWorkflowStepNumber(label: string): string {
  return (label ?? "").replace(/^\d+[a-z]?\.\s*/i, "").trim();
}
